const mapInterfaceCreate = (data) => {
  const newData = {
    COMPANY_CODE: data.COMPANY_CODE,
    REFERENCE: data.REFERENCE,
    TAX_ID: data.TAX_ID,
    CONTRACT_TYPE: data.CONTRACT_TYPE,
    CURRENCY: data.CURRENCY,
    LOAN_AMOUNT: data.LOAN_AMOUNT,
    PAYMENT_DOC_DATE: data.PAYMENT_DOC_DATE,
    PAYMENT_POST_DATE: data.PAYMENT_POST_DATE,
    REGISTRATION_TYPE: data.REGISTRATION_TYPE,
    TITLE: data.TITLE,
    NAME: data.NAME,
    LAST_NAME: data.LAST_NAME,
    BRANCH_CODE: data.BRANCH_CODE,
    MOBILE_PHONE: data.MOBILE_PHONE,
    EMAIL: data.EMAIL,
    ADDRESS: data.ADDRESS,
    POSTAL_CODE: data.POSTAL_CODE,
    REGION: data.REGION,
    BANK_KEY: data.BANK_KEY,
    BANK_ACCOUNT: data.BANK_ACCOUNT,
    ACCT_HOLDER: data.ACCT_HOLDER,
    BANK_TYPE: data.BANK_TYPE,
    CUSTOMER_PAY_TERM: data.CUSTOMER_PAY_TERM,
    VENDOR_PAY_TERM: data.VENDOR_PAY_TERM,
    STAMP_DUTY_FLAG: data.STAMP_DUTY_FLAG,
    STAMP_DUTY_AMOUNT: data.STAMP_DUTY_AMOUNT,
    SUM_DEFF_VAT_AMOUNT: data.SUM_DEFF_VAT_AMOUNT,
    INTEREST_AMOUNT: data.INTEREST_AMOUNT,
    DEFERRED_INCOME_AMOUNT: data.DEFERRED_INCOME_AMOUNT,
    // REVENUE_CAR_AMOUNT: data.REVENUE_CAR_AMOUNT,
    // REVENUE_MTC_AMOUNT: data.REVENUE_MTC_AMOUNT,
    VAT_AMOUNT: data.VAT_AMOUNT,
    VENDOR_AMOUNT: data.VENDOR_AMOUNT,
    INSPECTION_INCOME_AMOUNT: data.INSPECTION_INCOME_AMOUNT,
    TRANFER_INCOME_AMOUNT: data.TRANFER_INCOME_AMOUNT,
    CHASSIS_NO: data?.CHASSIS_NO || "",
    PAYMENT_METHOD: data?.PAYMENT_METHOD || "",
    // CONTRACT_SEQUENCE: data.CONTRACT_SEQUENCE,
    // AR_PAY_AMOUNT: data.AR_PAY_AMOUNT,
    // INTEREST_AMOUNT_2: data.INTEREST_AMOUNT_2,
    // VAT_AMOUNT: data.VAT_AMOUNT,
    // VAT_BASE_AMOUNT: data.VAT_BASE_AMOUNT,
    // DUE_DATE: data.DUE_DATE,
    sequences: data?.sequences.map((sequence) => {
      return {
        CONTRACT_SEQUENCE: sequence.CONTRACT_SEQUENCE,
        INTEREST_AMOUNT_2: sequence.INTEREST_AMOUNT_2,
        AR_PAY_AMOUNT: sequence.AR_PAY_AMOUNT,
        DEFFERED_VAT_AMOUNT: sequence.DEFFERED_VAT_AMOUNT,
        DEFFERED_BASE_AMOUNT: sequence.DEFFERED_BASE_AMOUNT,
        REVENUE_CAR_AMOUNT: sequence?.REVENUE_CAR_AMOUNT,
        REVENUE_MTC_AMOUNT: sequence?.REVENUE_MTC_AMOUNT,
        DUE_DATE: sequence.DUE_DATE,
      };
    }),
    MESSAGE: data.MESSAGE,
    MESSAGE_TYPE: data.MESSAGE_TYPE,
    sendSap: data.sendSap,
    sendSapAt: data.sendSapAt,
    createdAt: data.createdAt,
    timestamp: data.timestamp,
  };
  return newData;
};

const mapARClear = (data) => {
  const newData = {
    INTERFACE_ID: data.INTERFACE_ID,
    COMPANY_CODE: data.COMPANY_CODE,
    REFERENCE: data.REFERENCE,
    CONTRACT_TYPE: data.CONTRACT_TYPE,
    CURRENCY: data.CURRENCY,
    AR_CLEAR_DOC_DATE: data.AR_CLEAR_DOC_DATE,
    AR_CLEAR_POST_DATE: data.AR_CLEAR_POST_DATE,
    CONTRACT_PERIOD: data.CONTRACT_PERIOD,
    AR_PAY_AMOUNT: data.AR_PAY_AMOUNT,
    INTEREST_AMOUNT: data.INTEREST_AMOUNT,
    IN_PAYMENT_TYPE: data.IN_PAYMENT_TYPE,
    TAX_ID: data.TAX_ID,
    VAT_AMOUNT: data.VAT_AMOUNT,
    INV_BASE_AMOUNT: data.INV_BASE_AMOUNT,
    RECEIPT_TAX_INV_NO: data.RECEIPT_TAX_INV_NO,
    CLOSE_CONTRACT_FLAG: data.CLOSE_CONTRACT_FLAG,
    FINAL_PAYMENT_FLAG: data.FINAL_PAYMENT_FLAG,
    DISCOUNT_AMOUNT: data.DISCOUNT_AMOUNT,
    OVERPAID_AMOUNT: data.OVERPAID_AMOUNT,
    DEFERRED_INT_CLEAR: data.DEFERRED_INT_CLEAR,
    DEFAULT_INTEREST: data.DEFAULT_INTEREST,
    COLLECTION_FEE: data.COLLECTION_FEE,
    CANCEL_CONTRACT_FEE: data.CANCEL_CONTRACT_FEE,
    OPPORTUNITY_COST: data.OPPORTUNITY_COST, // MARK
    OTHER_REVENUE: data.OTHER_REVENUE, // MARK
    OPP_COST_VAT_AMT: data?.OPP_COST_VAT_AMT,
    OTH_VAT_AMT: data?.OTH_VAT_AMT,
    ADD_INTEREST: data?.ADD_INTEREST,
    ADD_INTEREST_VAT_AMT: data?.ADD_INTEREST_VAT_AMT,
    CAR_SALE_REVENUE_FLAG: data?.CAR_SALE_REVENUE_FLAG,

    MESSAGE: data.MESSAGE,
    MESSAGE_TYPE: data.MESSAGE_TYPE,
    sendSap: data.sendSap,
    sendSapAt: data.sendSapAt,
    createdAt: data.createdAt,
    timestamp: data.timestamp,
    period: data.period,
  };
  return newData;
};

const mapAccruedInterest = (data) => {
  const newData = {
    INTERFACE_ID: data.INTERFACE_ID,
    COMPANY_CODE: data.COMPANY_CODE,
    REFERENCE: data.REFERENCE,
    TAX_ID: data.TAX_ID,
    CONTRACT_TYPE: data.CONTRACT_TYPE,
    CURRENCY: data.CURRENCY,
    INT_ACCRUE_DOC_DATE: data.INT_ACCRUE_DOC_DATE,
    INT_ACCRUE_POST_DATE: data.INT_ACCRUE_POST_DATE,
    ACCR_INTEREST_RECEIVABLE: data.ACCR_INTEREST_RECEIVABLE,
    DEFAULT_INTEREST: data.DEFAULT_INTEREST,
    TRANSACTION_NOTE: data.TRANSACTION_NOTE,
    MESSAGE: data.MESSAGE,
    MESSAGE_TYPE: data.MESSAGE_TYPE,
    sendSap: data.sendSap,
    sendSapAt: data.sendSapAt,
    period: data.period,
    period_penalty_list: data?.period_penalty_list,
    createdAt: data.createdAt,
    timestamp: data.timestamp,
    paid_date: data.paid_date,
    total_previous: data.total_previous || 0,
  };
  return newData;
};

const mapPostOtherRevenue = (data) => {
  const newData = {
    INTERFACE_ID: data.INTERFACE_ID,
    COMPANY_CODE: data.COMPANY_CODE,
    REFERENCE: data.REFERENCE,
    TAX_ID: data.TAX_ID,
    CONTRACT_TYPE: data.CONTRACT_TYPE,
    CONTRACT_SEQUENCE: data.CONTRACT_SEQUENCE,
    CURRENCY: data.CURRENCY,
    AR_DOC_DATE: data.AR_DOC_DATE,
    AR_POST_DATE: data.AR_POST_DATE,
    COLLECTION_FEE: data.COLLECTION_FEE,
    CANCEL_CONTRACT_FEE: data.CANCEL_CONTRACT_FEE,
    OPPORTUNITY_COST: data.OPPORTUNITY_COST,
    OPP_COST_VAT_AMT: data.OPP_COST_VAT_AMT,

    // Return
    MESSAGE: data.MESSAGE,
    MESSAGE_TYPE: data.MESSAGE_TYPE,

    // MY FIELD
    createdAt: data.createdAt,
    timestamp: data.timestamp,
    category: data?.category,
    sendSap: data?.sendSap,
    sendSapAt: data?.sendSapAt,
    period: data?.period,
  };
  return newData;
};

const mapContractCancel = (data) => {
  const newData = {
    COMPANY_CODE: data.COMPANY_CODE,
    REFERENCE: data.REFERENCE,
    CONTRACT_TYPE: data.CONTRACT_TYPE,
    CANCEL_DOC_DATE: data.CANCEL_DOC_DATE,
    CANCEL_CONTRACT: data.CANCEL_CONTRACT,
    REVERSE_CANCEL_CONTRACT: data.REVERSE_CANCEL_CONTRACT,

    // Return
    MESSAGE: data.MESSAGE,
    MESSAGE_TYPE: data.MESSAGE_TYPE,

    // MY FIELD
    createdAt: data.createdAt,
    timestamp: data.timestamp,
    category: data?.category,
    sendSap: data?.sendSap,
    sendSapAt: data?.sendSapAt,
  };
  return newData;
};

const mapSeizeVehicle = (data) => {
  const newData = {
    COMPANY_CODE: data.COMPANY_CODE,
    REFERENCE: data.REFERENCE,
    TAX_ID: data.TAX_ID,
    CONTRACT_TYPE: data.CONTRACT_TYPE,
    DOC_DATE: data.DOC_DATE,
    POST_DATE: data.POSTAL_CODE,
    PLANT: data.PLANT,
    LOCATION: data.LOCATION,
    VEHICLE_TYPE: data.VEHICLE_TYPE,
    COLOR: data.COLOR,
    PLATE_NO: data.PLATE_NO,
    PLATE_PROVINCE: data.PLATE_PROVINCE,
    CHASSIS_NO: data.CHASSIS_NO,
    BRAND: data?.BRAND,
    MODEL: data?.MODEL,
    SUB_MODEL: data?.SUB_MODEL,
    MF_YEAR: data?.MF_YEAR,
    GEAR_TYPE: data?.GEAR_TYPE,
    CONTRACT_MEAN_PRICE: data?.CONTRACT_MEAN_PRICE,
    CUR_MEAN_PRICE: data?.CUR_MEAN_PRICE,
    ENGINE_NO: data?.ENGINE_NO,
    REG_YEAR: data?.REG_YEAR,
    MILEAGE: data?.MILEAGE,
    LICENSE_EXP_DATE: data?.LICENSE_EXP_DATE,
    INSURANCE_EXP_DATE: data?.INSURANCE_EXP_DATE,
    CONTRACT_CANCEL_DATE: data?.CONTRACT_CANCEL_DATE,
    OUTSTANDING_PERIOD: data?.OUTSTANDING_PERIOD,
    ASSET_FOR_SALES: data?.ASSET_FOR_SALES,
    OUTSTANDING_AR: data?.OUTSTANDING_AR,
    OUTSTANDING_INTEREST: data?.OUTSTANDING_INTEREST,
    OUTSTANDING_TAX: data?.OUTSTANDING_TAX,

    // Return
    MESSAGE: data.MESSAGE,
    MESSAGE_TYPE: data.MESSAGE_TYPE,
    ...data,
  };
  return newData;
};

const mapTransferVehicle = (data) => {
  const newData = {
    COMPANY_CODE: data.COMPANY_CODE,
    REFERENCE: data.REFERENCE,
    DOC_DATE: data.DOC_DATE,
    POST_DATE: data.POST_DATE,
    SOURCE_PLANT: data.SOURCE_PLANT,
    SOURCE_LOCATION: data.SOURCE_LOCATION,
    DEST_PLANT: data.DEST_PLANT,
    DEST_LOCATION: data.DEST_LOCATION,
    VEHICLE_TYPE: data.VEHICLE_TYPE,

    // Return
    MESSAGE: data.MESSAGE,
    MESSAGE_TYPE: data.MESSAGE_TYPE,
    ...data,
  };
  return newData;
};

export {
  mapTransferVehicle,
  mapSeizeVehicle,
  mapInterfaceCreate,
  mapARClear,
  mapAccruedInterest,
  mapPostOtherRevenue,
  mapContractCancel,
};
